import React from 'react';
import Avatar from '@mui/material/Avatar';
import { getStudentAvatar } from '../../shared/studentAvatar';

export default function StudentResultAvatar({ studentId, studentName }) {
  const theme = getStudentAvatar(studentId);
  return <Avatar sx={{ width: 48, height: 48, bgcolor: theme.bgColor, border: '2px solid',
    borderColor: theme.borderColor, fontSize: 25 }} aria-label={`${studentName || 'Öğrenci'} hayvan avatarı`}>
    {theme.avatar}
  </Avatar>;
}
